var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 17h20",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M1.4 7.79A10.51 10.51 0 0 1 4 6.17a89.034 89.034 0 0 1 8.31-3.54.88.88 0 0 1 .79 0c.44.27.59 1.1.65 1.8a34.32 34.32 0 0 1-2.59 15.83 6.171 6.171 0 0 1-1 1.75 1.29 1.29 0 0 1-1.49.44c-.8-.45-1.26-1.74-1.47-2.95a8.06 8.06 0 0 1 .12-4 5.57 5.57 0 0 1 1.11-1.76 27 27 0 0 1 8.51-6.89l1.26 4.21c.09.32.25.69.47.66.22-.03.21-.16.28-.3A28.432 28.432 0 0 0 21.4 5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14l3-3m-3 0l3 3",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignature);
export default __webpack_public_path__ + "static/media/signature.8885a508b86d9d8e6413fc532664c72a.svg";
export { ForwardRef as ReactComponent };